import { render, staticRenderFns } from "./credential-change-user-component.vue?vue&type=template&id=2850c803&"
import script from "./credential-change-user-component.vue?vue&type=script&lang=js&"
export * from "./credential-change-user-component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports